module.exports = __webpack_public_path__ + "static/main_visual_pc-9bde0983ef459280040ab2bc48cd747c.jpg";